export const INCLUSION_STATE = {
  INCLUDE: "include",
  EXCLUDE: "exclude",
} as const;
